import React from "react";

import { FooterSocialWrapper, WebFooter } from "./Footer.styles";
import FooterLegalInfo from "./FooterLegalInfo";
import SocialButtons from "./SocialButtons";
import BannerApp from "./BannerApp";

function FooterContainer() {
    return (
        <WebFooter className="web-footer">
            <FooterSocialWrapper>
                <SocialButtons />
                <BannerApp />
            </FooterSocialWrapper>
            <FooterLegalInfo />
        </WebFooter>
    );
}

export default FooterContainer;
